import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { apiRegister } from '../../api';
import RegisterPageStyle from '../styles&pics/RegisterPageStyle';

const RegisterPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Οι κωδικοί πρόσβασης δεν ταιριάζουν.');
      return;
    }

    setLoading(true);

    try {
      await apiRegister(username, email, password);
      alert('Η εγγραφή ολοκληρώθηκε! Μπορείτε τώρα να συνδεθείτε.');
      navigate('/login');
    } catch (err) {
      setError(err.message || 'Σφάλμα εγγραφής. Το όνομα χρήστη ή το email μπορεί να υπάρχει ήδη.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <RegisterPageStyle />
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-card">
            <div className="auth-header">
              <UserPlus className="auth-icon" />
              <h1>Εγγραφή</h1>
              <p>Δημιουργήστε νέο λογαριασμό</p>
            </div>

            <form onSubmit={handleSubmit} className="auth-form">
              {error && <div className="auth-error">{error}</div>}
              
              <div className="form-group">
                <label htmlFor="username">Όνομα Χρήστη</label>
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Κωδικός Πρόσβασης</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Επιβεβαίωση Κωδικού</label>
                <input
                  id="confirmPassword"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="auth-submit" disabled={loading}>
                {loading ? 'Εγγραφή...' : 'Εγγραφή'}
              </button>
            </form>

            <div className="auth-footer">
              <p>Έχετε ήδη λογαριασμό;</p>
              <button onClick={() => navigate('/login')} className="auth-link">
                Σύνδεση
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterPage;
